// server-errors.interceptor.ts
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { mergeMap, retryWhen } from 'rxjs/operators';

@Injectable()
export class ServerErrorsInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // If the call fails, retry 2 times before throwing an error
    return next.handle(request).pipe(retryWhen(error => {
      let errors = 0;

      return error
        .pipe(mergeMap((e: any) => {
          if (errors++ >= 2 || e.status < 500) {
            return throwError(e);
          }
          return of(e);
        }));
    }));
  }
}
